import React from 'react';
import PropTypes from 'prop-types';

import TableView from 'components/organisms/TableView';
import DashboardTemplate from 'components/templates/DashboardTemplate';

class Markets extends React.PureComponent {
  state = {
    isEditModalOpen: false,
    id: null,
    initialValues: {},
    createEditHeaderContent: '',
    createEditBtnContent: '',
    handleCreateEditAction: () => {}
  };

  componentDidMount () {
    this.props.loadCompaniesList();
  }

  resetModalState = () => {
    this.props.loadResetError();
    this.setState({
      initialValues: {},
      id: null,
      createEditHeaderContent: '',
      createEditBtnContent: ''
    });
  };
  handleEditModalOpen = async id => {
    this.setState({
      id: id,
      isEditModalOpen: true,
      initialValues: {
        ...this.props.loadSelectedCompaniesList(id)
      },
      createEditHeaderContent: 'Edit company',
      createEditBtnContent: 'Save',
      handleCreateEditAction: this.handleSubmitUpdate
    });
  };
  handleCreateModalOpen = () =>
    this.setState({
      isEditModalOpen: true,
      createEditHeaderContent: 'Create new company',
      createEditBtnContent: 'Create',
      handleCreateEditAction: this.handleSubmitNew
    });
  handleCreateModalClose = () => {
    this.resetModalState();
    this.setState({
      isEditModalOpen: false
    });
  };

  isErrorDefined = ({ error } = this.props) => error !== '' || error;

  handleSubmitNew = data => {
    const { loadCreateCompaniesList } = this.props;

    loadCreateCompaniesList(data, () => {
      if (!this.isErrorDefined()) {
        this.handleCreateModalClose();
      }
    });
  };
  handleSubmitUpdate = data => {
    const { loadCompaniesListToUpdate } = this.props;
    const { id } = this.state;
    const params = { data, id };

    loadCompaniesListToUpdate(params, () => {
      if (!this.isErrorDefined()) {
        this.handleCreateModalClose();
      }
    });
  };

  render () {
    const {
      isEditModalOpen,
      initialValues,
      createEditHeaderContent,
      createEditBtnContent,
      handleCreateEditAction
    } = this.state;
    const { isDataLoading, isRequestLoading, companiesList, error } = this.props;
    const contentHeaderActions = [
      {
        content: 'Create new company',
        type: 'standardAdd',
        action: this.handleCreateModalOpen,
        floated: 'right'
      }
    ];
    const actionsList = [
      {
        content: 'Edit',
        type: 'standardEdit',
        action: this.handleEditModalOpen
      }
    ];
    const fieldList = [
      {
        type: 'string',
        label: 'Name',
        name: 'name',
        required: true
      }
    ];

    const tableHeaderLabels = [
      {
        name: 'id',
        label: 'ID'
      },
      {
        name: 'date_created',
        label: 'Date Created'
      },
      {
        name: 'last_updated',
        label: 'Last Updated'
      },
      {
        name: 'name',
        label: 'Company Name'
      }
    ];

    return (
      <DashboardTemplate>
        <TableView
          tableHeaderLabels={tableHeaderLabels}
          breadCrumbContent={['Companies']}
          handleCreateModalClose={this.handleCreateModalClose}
          handleDeleteModalClose={this.handleDeleteModalClose}
          tableActionsList={actionsList}
          dataList={companiesList}
          contentHeaderActions={contentHeaderActions}
          isDataLoading={isDataLoading}
          isRequestLoading={isRequestLoading}
          error={error}
          handleCreateEditAction={handleCreateEditAction}
          initialValues={initialValues}
          isEditModalOpen={isEditModalOpen}
          fieldList={fieldList}
          createEditHeaderContent={createEditHeaderContent}
          createEditBtnContent={createEditBtnContent}
        />
      </DashboardTemplate>
    );
  }
}

Markets.propTypes = {
  loadSelectedCompaniesList: PropTypes.func.isRequired,
  loadCreateCompaniesList: PropTypes.func.isRequired,
  loadCompaniesListToUpdate: PropTypes.func.isRequired,
  loadCompaniesList: PropTypes.func.isRequired,
  loadResetError: PropTypes.func.isRequired,
  isDataLoading: PropTypes.bool.isRequired,
  isRequestLoading: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  companiesList: PropTypes.array.isRequired
};

export default Markets;
